/// <reference path="../_all.ts" />

module misc {
  'use strict';

  export interface IAdvancedNumberFilter extends ng.IFilterService {
      (name: 'advancedNumber'): (value:number, divisor: number) => string;
  }


  export function AdvancedNumberFilter() {

     return function(value:number, divisor: number){
       var resources = {
                        "Femto": "f",
                        "Giga": "G",
                        "Kilo": "K",
                        "Mega": "M",
                        "Micro": "µ",
                        "Mili": "m",
                        "Nano": "n",
                        "Peta": "P",
                        "Pico": "p",
                        "Tera": "T"};

       var postfix = [ resources.Peta, resources.Tera, resources.Giga, resources.Mega, resources.Kilo, '', resources.Mili, resources.Micro, resources.Nano, resources.Pico, resources.Femto ];

      if(typeof value == 'undefined') return '';

      divisor = divisor || 1000;

      var index = 5;

      while (value > divisor && value != 0) {
        value = value / divisor;
        index--;
      }

      while (value < 1 && value != 0) {
        value = value * divisor;
        index++;
      }

      var fixed = 2;
      if (value > 9.99) fixed = 1;
      if (value > 99.9) fixed = 0;
      if (value > 999) fixed = 0;


      return value.toFixed(fixed) + ' ' + postfix[index];
     }
  }


}